/* ============================================================================
   csf-home-hero.js — draws the curved connector lines for Home: Hero.
   Uses real pixel coordinates (no viewBox distortion) so the arcs are even on
   every screen. Each arc bows perpendicular to the segment for a clean curve.
   ========================================================================== */
(function () {
  function draw(hero) {
    var svg = hero.querySelector('.vhero__lines');
    var path = svg && svg.querySelector('path');
    if (!path) return;
    var w = hero.clientWidth, h = hero.clientHeight;
    if (!w || !h) return;
    svg.setAttribute('viewBox', '0 0 ' + w + ' ' + h);            // 1:1 with the box -> no distortion
    var bow = parseFloat(svg.getAttribute('data-bow') || '8') / 100;
    var pills = hero.querySelectorAll('.vhero__pill');
    var d = '', prev = null;
    pills.forEach(function (p) {
      var x = p.offsetLeft, y = p.offsetTop;                       // pill anchor (centre, due to translate -50%)
      var connect = p.getAttribute('data-connect') === 'true';
      if (prev && connect) {
        var dx = x - prev.x, dy = y - prev.y;
        var len = Math.sqrt(dx * dx + dy * dy) || 1;
        var nx = -dy / len, ny = dx / len;                        // unit perpendicular
        var amt = len * bow;                                      // bow proportional to segment length
        var cx = (prev.x + x) / 2 + nx * amt;
        var cy = (prev.y + y) / 2 + ny * amt;
        d += 'M' + prev.x + ' ' + prev.y + ' Q' + cx + ' ' + cy + ' ' + x + ' ' + y + ' ';
      }
      prev = { x: x, y: y };
    });
    path.setAttribute('d', d);
  }
  function init() { document.querySelectorAll('.vhero').forEach(draw); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('load', init);
  var t;
  window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(init, 150); });
  document.addEventListener('shopify:section:load', init);
})();
